module.exports = __webpack_public_path__ + "img/iconoconfianza.17f674b5.svg";